var _defs, _polygon, _polygon2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolPack373({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.67 0.78 0.58 7.46 14.77 7.46 7.67 0.78"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.67 14.67 14.77 7.99 0.58 7.99 7.67 14.67"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.84,13.36v-.53h1.57v1.68a2.68,2.68,0,0,1-.74.53,1.9,1.9,0,0,1-.8.18,1.79,1.79,0,0,1-1-.27,1.84,1.84,0,0,1-.67-.8A2.85,2.85,0,0,1,12,12.9a3.08,3.08,0,0,1,.25-1.3,1.84,1.84,0,0,1,.65-.81,1.77,1.77,0,0,1,1-.26,1.66,1.66,0,0,1,.72.15,1.38,1.38,0,0,1,.5.43,2.15,2.15,0,0,1,.3.76l-.45.15a1.73,1.73,0,0,0-.22-.57.88.88,0,0,0-.36-.3,1.18,1.18,0,0,0-.5-.11,1.25,1.25,0,0,0-.7.2,1.37,1.37,0,0,0-.47.61,2.53,2.53,0,0,0-.18,1,2.13,2.13,0,0,0,.38,1.37,1.25,1.25,0,0,0,1,.45,1.62,1.62,0,0,0,1.08-.47v-.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolPack373);
export default __webpack_public_path__ + "static/media/Symbol_pack_373.515f4483a3bd2acd229c851501c1d5c1.svg";
export { ForwardRef as ReactComponent };